module.exports = __webpack_public_path__ + "img/circle-j.4ce44c6b.svg";